export default "__VITE_ASSET__4326a9ea__"